import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Landing from './pages/landing';

import { RECAPTCHA_KEY } from './utils/constants';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import VerifyEmail from './pages/auth/verify_email';
import { withTranslation } from 'react-i18next';

const PrivateRouter = lazy(() => import('./private_router'));
const Register = lazy(() => import('./pages/auth/register'));
const LoginPage = lazy(() => import('./pages/auth/login'));

const Router = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/">
        <Route index element={<Landing />} />
      </Route>
      <Route path=")" element={<Navigate to="/" />} />
      <Route
        path="/login"
        element={
          <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY} useEnterprise="true">
            <Suspense fallback={<div />}>
              <LoginPage />
            </Suspense>
          </GoogleReCaptchaProvider>
        }
      />
      <Route
        path="/register"
        element={
          <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY} useEnterprise="true">
            <Suspense fallback={<div />}>
              <Register />
            </Suspense>
          </GoogleReCaptchaProvider>
        }
      />
      <Route
        path="/verify-email"
        element={
          <Suspense fallback={<div />}>
            <VerifyEmail />
          </Suspense>
        }
      />

      <Route
        path="*"
        element={
          <Suspense fallback={<div />}>
            <PrivateRouter />
          </Suspense>
        }
      />
    </Routes>
  </BrowserRouter>
);

export default withTranslation()(Router);
